import React, { FC, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useToast } from '@common/toast';
import { useUsersPasswordVerification } from '@repository/users/useUsers';
import { Name } from '@components/loginModal/find/form/Name';
import { BirthDate } from '@components/loginModal/find/form/BirthDate';
import { MobileWrap } from '@components/loginModal/find/form/mobile';
import { FindPasswordStepType } from '@components/loginModal/find/password/index';
import styles from '@components/loginModal/find/find.module.scss';
import AuthFindFormField from '@domain/rq/users/AuthFindFormField';
import classnames from 'classnames/bind';

const cx = classnames.bind(styles);

interface FindPasswordConfirmProps {
  authFormField: AuthFindFormField;
  setAuthFormField: (field: AuthFindFormField) => void;
  setFindPasswordStep: (step: FindPasswordStepType) => void;
}

const FindPasswordConfirm: FC<FindPasswordConfirmProps> = ({
  setFindPasswordStep,
  authFormField,
  setAuthFormField,
}) => {
  const Toast = useToast();
  const [isSuccessMobileAuth, setIsSuccessMobileAuth] = useState(false);
  const { mutateAsync: fetchPasswordVerification } = useUsersPasswordVerification();

  const methods = useForm<AuthFindFormField>({ mode: 'onChange' });
  const {
    watch,
    handleSubmit,
    formState: { errors },
  } = methods;

  const name = watch('name');
  const birthDate = watch('birthDate');
  const genderFlag = watch('genderFlag');

  const isDisabledConfirmIdBtn =
    !name || !birthDate || !genderFlag || !isSuccessMobileAuth || !!Object.values(errors).length;

  const onSubmit = async (authFindFormField: AuthFindFormField) => {
    try {
      authFindFormField.id = authFormField.id; //전단계 아이디
      const { success } = await fetchPasswordVerification(authFindFormField);
      if (success) {
        setAuthFormField(authFindFormField);
        setFindPasswordStep('RESET');
      }
    } catch (err: any) {
      Toast({ type: 'error', iconType: 'info', content: err?.response?.data.message });
    }
  };

  return (
    <FormProvider {...methods}>
      <div className={cx('userInfoArea')}>
        <form onSubmit={handleSubmit(onSubmit)}>
          <Name />
          <BirthDate />
          <MobileWrap setIsSuccessMobileAuth={setIsSuccessMobileAuth} />
          <button className={cx('btnFindInfo')} type="submit" disabled={isDisabledConfirmIdBtn}>
            비밀번호 재설정
          </button>
        </form>
      </div>
    </FormProvider>
  );
};

export default FindPasswordConfirm;
